<div class="row justify-content-md-center">
  <div class="col-sm-12 col-md-6 col-md-auto">

    <!-- Sign In -->
    <div class="sign__container">

      <div style="margin-bottom: 30px; text-align: center;">
        <a href="http://www.telego.com/" style="box-sizing: border-box; color: #2196F3; text-decoration: none;">
          <img alt="TeleGo" style="-ms-interpolation-mode: bicubic; max-width: 100%;"
               src="../../../assets/images/logo-with-slogan.svg">
        </a>
      </div>

      <div class="card card-default">

        <div class="card-body">
          <h4 class="card-title">Create Your Password</h4>
          <form [formGroup]="form" novalidate (ngSubmit)="onSubmit()">
            <div class="alert alert-danger alert-dismissible" role="alert" *ngIf="serverError" >
              Your session expired, please contact <a href="mailto:support@telego.net">support&#64;telego.net</a> to request a new invitation.
            </div>
            <app-mat-text-input formControlName="username" label="E-mail Address" name="username" [submitted]="submitted" ></app-mat-text-input>
            <app-mat-password-input class="password" formControlName="newPassword" label="New Password" name="newPassword" [submitted]="submitted"></app-mat-password-input>
            <app-mat-password-input formControlName="confirmPassword" type="password" label="Re-enter New Password" name="confirmPassword" [submitted]="submitted"
                                    [customErrors]="{mismatchedFields: 'Passwords do not match'}"></app-mat-password-input>

            <button type="submit" mat-raised-button color="primary" [promiseBtn]="buttonSubmitPromise">
              Submit
            </button>
          </form>
        </div> <!-- / .panel-body -->

      </div> <!-- / .card -->
    </div> <!-- / .sign__conteiner -->

  </div>
</div>
<footer class="page__footer custom">
  <div class="row">
    <div class="col-xs-12 page__footer__holder">
      <span class="page__footer__year">{{currentYear}}</span> © TeleGo Inc. ® All rights reserved.
      <a href="https://kb.telego.com/article/110-privacy-policy" target="_blank">Privacy</a> and
      <a href="https://kb.telego.com/article/111-telego-terms-and-conditions" target="_blank">Terms</a>
    </div>
  </div>
</footer>
